import { createContext, useContext, useEffect, useState, type ReactNode } from "react";
import { apiGet, apiSend, ensureCsrf } from "./api";
import type { CurrentUser } from "./types";

interface AuthState {
  user: CurrentUser | null;
  loading: boolean;
  login: (email: string, password: string) => Promise<void>;
  loginGoogle: (credential: string) => Promise<void>;
  logout: () => Promise<void>;
}

const Ctx = createContext<AuthState>(null as any);
export const useAuth = () => useContext(Ctx);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<CurrentUser | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      await ensureCsrf();
      try { setUser(await apiGet<CurrentUser>("/api/auth/me/")); }
      catch { setUser(null); }
      finally { setLoading(false); }
    })();
  }, []);

  const login = async (email: string, password: string) => {
    const u = await apiSend<CurrentUser>("/api/auth/login/", "POST", { email, password });
    setUser(u);
  };
  const loginGoogle = async (credential: string) => {
    const u = await apiSend<CurrentUser>("/api/auth/google/", "POST", { credential });
    setUser(u);
  };
  const logout = async () => {
    await apiSend("/api/auth/logout/", "POST", {});
    setUser(null);
  };

  return <Ctx.Provider value={{ user, loading, login, loginGoogle, logout }}>{children}</Ctx.Provider>;
}
